import React, { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import dateFormat from "dateformat";
import { Link } from "react-router-dom";
import { Container, Row } from "reactstrap";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  InputLabel,
} from "@mui/material";
import Box from "@mui/material/Box";
import Audits from "./EditAudits.js";
import Userdata from "./EditUserdata";

const AuditResultpage = () => {
  const [temporary, settemporary] = useState([]);
  const [find, setfind] = useState(false);
  const [platform, setplatform] = React.useState([]);
  const [templist, settemplist] = React.useState([]);
  const [platformdata, setPlatformdata] = useState([]);
  const [page, setPage] = useState(0);

  const [itemselected, setItemselected] = React.useState([]);
  const [selected, setSelected] = React.useState([]);
  const [platformuserdata, setPlatformuserdata] = React.useState([]);
  const [userdata, setUserdata] = React.useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/generics/platform/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setplatform(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/templateslist`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => settemplist(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [state, setState] = useState({
    name: "",
    os_type: "",
    compliance: "",
    selected_audits: "",
    submitted: false,
    newsubmitCheck: false,
    errorMessage: "",
  });

  useEffect(() => {
    const Audits = window.sessionStorage.getItem("Audits");
    const Platform = window.sessionStorage.getItem("platform");
    const Templatename = window.sessionStorage.getItem("templatename");
    const Ostype = window.sessionStorage.getItem("os_type");
    const Compliance = window.sessionStorage.getItem("compliance");
    const newVal = Ostype + ":" + Compliance;

    fetch(
      `${process.env.REACT_APP_API_URL}/api/organizationcomplianceaudits/${newVal}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => {
        setPlatformdata(resp[0]);
      })
      .catch((error) => {
        console.error(error);
      });
      const tempID = window.sessionStorage.getItem("TempID");
      const temp = {
        os_type: Ostype,
        platform: Platform,
        selected_audits: Audits.toString(),
        temp_id: tempID.toString()
      };   
      fetch(
        `${process.env.REACT_APP_API_URL}/api/profileedituserdata/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("token"),
          },
          body: JSON.stringify(temp),
        }
      )
        .then((resp) => resp.json())
        .then((data) => {
          setPlatformuserdata(data)
          data.map((usrdata) => {
            setUserdata((prevState) => ({
              ...prevState,
              [usrdata.variable]: usrdata.output,
            }));
          });   
        })
        .catch((error) => {
          console.error(error);
        });        
    const name = Templatename;
    const platform = Platform;
    const os_type = Ostype;
    const finalValue = Audits.split(",").map((val) => {
      return val;
    });
    setSelected(finalValue);
    const id1 = "name";
    const id2 = "os_type";
    const id3 = "platform";
    const id4 = "compliance";
    setState((prevState) => ({
      ...prevState,
      [id1]: name,
      [id2]: os_type,
      [id3]: platform,
      [id4]: Compliance,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id1]: name,
      [id2]: os_type,
      [id3]: platform,
      [id4]: Compliance,
    }));
  }, []);

  const handleChange = (e) => {
    // e.preventDefault
    setfind(false);
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    const checklab = templist.map((temp) => {
      if (temp.name === value) {
        setfind(true);
      }
    });
  };

  const handlePageChange = (e) => {
    e.preventDefault; 
    setPage(1);   
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    window.sessionStorage.setItem("platform", state.os_type);
    const newuserdata = JSON.stringify(userdata)
    const temp = {
      name: state.name,
      os_type: state.os_type,
      compliance: state.compliance,
      selected_audits: selected.toString(),
      user_data: newuserdata
    };
    const tempID = window.sessionStorage.getItem("TempID");
    fetch(`${process.env.REACT_APP_API_URL}/api/templates/${tempID}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(temp),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.name) {
          window.location.reload();
        } else {
          if (data.username) {
            setState({ errorMessage: data.name[0] });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
    window.location.href = "/admin/profile";
  };

  return (
    <>
      {window.localStorage.getItem("audit_run_limit") ===
      "License limitation crossed" ? (
        <Marquee pauseOnHover="false" style={{ color: "red" }}>
          You have utilized all your trail "Audit", Please contact{" "}
          <a
            href="mailto:sales@zippyops.com"
            style={{ marginLeft: "5px", color: "red" }}
          >
            sales@zippyops.com
          </a>{" "}
          for subscription.
        </Marquee>
      ) : (
        ""
      )}
      <React.Fragment>
        <Container className="mt--6" fluid>
          <Card>
            <CardHeader
              action={
                <React.Fragment>
                  <div>
                    <button
                      className="bg-blueGray-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      type="button"
                      // style={{ float: "right" }}
                    >
                      <Link
                        to={{
                          pathname: "/admin/profile",
                        }}
                      >
                        Cancel
                      </Link>
                    </button>
                    {page === 0 ?
                    <button
                      className={
                        state.name && state.os_type && selected.length > 0
                          ? "bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                          : "bg-lightBlue-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      }
                      // color="primary"
                      size="sm"
                      onClick={handlePageChange}
                      style={{ float: "right" }}
                      disabled={
                        state.name && state.os_type && selected.length > 0
                          ? false
                          : true
                      }
                    >
                        Next
                    </button>
                    :
                    <button
                    className={
                      state.name && state.os_type && selected.length > 0
                        ? "bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                        : "bg-lightBlue-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    }
                    // color="primary"
                    size="sm"
                    onClick={handleSubmitClick}
                    style={{ float: "right" }}
                    disabled={
                      state.name && state.os_type && selected.length > 0
                        ? false
                        : true
                    }
                  >
                    <Link
                      to={{
                        pathname: "/admin/profile",
                      }}
                    >
                      Update
                    </Link>
                  </button>}                    
                  </div>
                </React.Fragment>
              }
              title="Update Profile"
            />
            <CardContent>
              <Grid container justify="center" spacing={3}>
                <Grid item xs={4}>
                  <span>
                    Profile Name : <strong>{state.name}</strong>{" "}
                  </span>
                </Grid>
                <Grid item xs={4}>
                  <span>
                    Platform : <strong>{state.platform}</strong>{" "}
                  </span>
                </Grid>
                <Grid item xs={4}>
                  <span>
                    Compliance : <strong>{state.compliance}</strong>{" "}
                  </span>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          {page === 0 ? (
            <React.Fragment>          
          {platformdata.Result ? (
            [
              platformdata.Result.length > 0 ? (
                <Row className="mt-3">
                  <div className="col">
                    <Audits
                      CisResults={platformdata.Result}
                      selected={selected}
                      setSelected={setSelected}
                      name={state.name}
                      os_type={state.os_type}
                      handleSubmitClick={handleSubmitClick}
                      itemselected={itemselected}
                      setItemselected={setItemselected}
                      setPage={setPage}
                    />
                  </div>
                </Row>
              ) : (
                <Row className="mt-3">
                  <div className="col">
                    <Card>
                      <CardContent>
                        <span>Loading ...</span>
                      </CardContent>
                    </Card>
                  </div>
                </Row>
              ),
            ]
          ) : (
            <Row className="mt-3">
              <div className="col">
                <Card>
                  <CardContent>
                    <span>Loading ...</span>
                  </CardContent>
                </Card>
              </div>
            </Row>
          )}
            </React.Fragment>
            ) : (    
              <React.Fragment>
              <Row className="mt-3">
                <div className="col">
                  <Userdata
                    selected={selected}
                    name={state.name}
                    os_type={state.os_type}
                    platform={state.platform}
                    handleSubmitClick={handleSubmitClick}
                    platformuserdata={platformuserdata}
                    userdata={userdata}
                    setUserdata={setUserdata}                   
                  />
                </div>
              </Row>
          </React.Fragment>
          )}
        </Container>
      </React.Fragment>
    </>
  );
};
export default AuditResultpage;